import {useDeleteBookingMutation} from 'hooks/ventrata/useDeleteBookingMutation'
import {useCurrency} from 'providers/EnvironmentProvider'
import {useCrossSelling} from 'providers/OrderDetailsProvider'
import {OrderProvider} from 'providers/OrderProvider'
import {useCallback} from 'react'
import {Ventrata} from 'types'
import {ga4} from 'utils/ga4'
import {getGa4BookingItems} from 'utils/getGa4BookingItems'
import {getHumanPrice} from 'utils/getHumanPrice'
import {Button} from '../system/Button'
import {Modal} from '../system/Modal'
import {ErrorMessage} from './ErrorMessage'

type Props = {
  booking: Ventrata.Booking
  onClose: () => void
}

export const DeleteModal = ({booking, onClose}: Props) => {
  const order = OrderProvider.useOrder()
  const currency = useCurrency()
  const crossSelling = useCrossSelling()
  const setOrder = OrderProvider.useOrderSetter()
  const deleteBookingMutation = useDeleteBookingMutation()
  const deleteBooking = deleteBookingMutation.mutate

  const onRemove = useCallback(() => {
    deleteBooking(
      {orderId: order.id, bookingUuid: booking.uuid},
      {
        onSuccess(updatedOrder) {
          ga4({
            event: 'remove_from_cart',
            ecommerce: {
              currency,
              value: getHumanPrice(booking.pricing?.retail),
              checkout_type: 'custom_checkout',
              items: getGa4BookingItems(booking, currency, crossSelling[booking.uuid]),
            },
          })

          setOrder(updatedOrder)
          onClose()
        },
      }
    )
  }, [booking, currency, deleteBooking, order.id, onClose, setOrder, crossSelling])

  return (
    <Modal>
      <div className="p-6 flex flex-col gap-6">
        <h4 className="font-bold text-lg">Delete item</h4>
        <p>
          Please confirm that you want to remove tour <span className="font-bold">{booking.option.title}</span> from
          your order
        </p>
        {deleteBookingMutation.error && <ErrorMessage error={deleteBookingMutation.error} />}
        <div className="flex gap-4">
          <Button.Secondary.Black onClick={onClose} className="basis-1/2">
            No, keep
          </Button.Secondary.Black>
          <Button.Primary.Red onClick={onRemove} className="basis-1/2">
            Yes, remove
          </Button.Primary.Red>
        </div>
      </div>
    </Modal>
  )
}
